let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("tlaAi")).then(() => parcelRequire('9LY57'));